// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDA5aFsqM72UbBpxoMJ19tdCgs0k29k_N0",
    authDomain: "dopamine-website.firebaseapp.com",
    projectId: "dopamine-website",
    storageBucket: "dopamine-website.firebasestorage.app",
    messagingSenderId: "61792872246",
    appId: "1:61792872246:web:54b23e658ca5ab1f367597",
    measurementId: "G-T54H51SJT1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);